export const AddNewProfileInfo = () => (
  <>
    <p>
      An end-user profile contains data (name address) and documents. The
      required data and documents vary per Country and Plan. In the following
      step you can add this data and documents and crosscheck with the
      requirements of the Country and Plan.
    </p>
    <p>
      When ordering DIDs and initiating Portings, you will able to use
      incomplete end-user profiles but you will have to complete these (via
      Profiles/End-use profiles) within 48 hours after submitting the order.
    </p>
    <p>
      <b>Note</b>
    </p>
    <p>
      In case of PSTN replacement it is always needed to create a unique
      end-user profile per DID.
    </p>
  </>
);
